import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  IconButton
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { headers, attachmentHeaders } from "../../../utils/utils";

const AttachmentSection = ({
  attachments,
  ticketData,
  raiseTicket,
  loadAttachments,
}) => {

  const [fileToDelete, setFileToDelete] = useState(null);


  const handleFileUpload = async (event) => {
    console.log("INSIDE ");
    const files = event.target.files;

    if (!files || files.length === 0) {
      console.log("No files selected");
      return;
    }

    if (!ticketData.id) {
      console.log("EMPTY");
      await raiseTicket(ticketData);
    }

    const formData1 = new FormData();
    Array.from(files).forEach((file) => formData1.append("files", file));
    formData1.append("microserviceName", "VYG-TICKET");
    formData1.append("resourceId", ticketData.id);

    try {
      // if (isTicketTrigger === false) {
      // setIsTicketTrigger(true)
      const response = await fetch(
        process.env.REACT_APP_ATTACHMENT + "/attachment/save",
        {
          method: "POST",
          body: formData1,
          headers: attachmentHeaders(),
        },
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Files uploaded successfully:", result);
        loadAttachments(ticketData.id);
      } else {
        console.error(
          `Failed to upload files: ${response.status} ${response.statusText}`,
        );
      }
      // }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

   // Function to handle file download
   const handleDownload = async (fileName) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_ATTACHMENT +
        `/attachment/download/${ticketData.id}/${fileName}`,
        {
          method: "GET",
          headers: headers(), // Ensure headers() returns valid headers
        },
      );

      if (!response.ok) {
        console.error("Error downloading the file:", response.statusText);
        return;
      }

      // Extract the file data as a blob
      const blob = await response.blob();

      // Create a blob URL for the file
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // File name for the downloaded file
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download file. Please try again.");
    }
  };

  const handleMarkForDelete = (attchmentId) => {
    setFileToDelete(attchmentId);
  };

  const handleCancelDelete = () => {
    setFileToDelete(null);
  };

  const handleConfirmDelete = async (attchmentId, index) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_ATTACHMENT + `/attachment/${attchmentId}`,
        {
          method: "DELETE",
          headers: headers(), // Ensure headers() returns valid headers
        },
      );

      if (response.ok) {
        loadAttachments(ticketData.id);
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("An error occurred while deleting the file.");
    } finally {
      setFileToDelete(null); // Reset to normal state
    }
  };



  return (
    <div>
      {/* Attachments Title */}
      <Box sx={{ display: "flex", alignItems: "center", mt: 4 }}>
        <AttachmentIcon />
        <Typography
          component="div"
          variant="body2"
          color="text.secondary"
          sx={{ ml: 1, fontWeight: 600 }}
        >
          Attachments
        </Typography>
      </Box>

      {/* Attachments List */}
      {attachments && (
        <Grid item xs={12}>
          <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2}>
            {attachments && attachments.length > 0 ? (
              attachments.map((attch, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  sx={{
                    padding: "8px",
                    margin: "4px",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "6px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                  }}
                >
                  {/* Download Button */}
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => handleDownload(attch.fileName)}
                    sx={{ textTransform: "none" }}
                    endIcon={<CloudDownloadIcon />}
                  >
                    {attch.fileName}
                  </Button>

                  {/* Delete / Confirm */}
                  {fileToDelete === attch.id ? (
                    <Box display="flex" alignItems="center" sx={{ ml: 1 }}>
                      <IconButton
                        color="error"
                        onClick={handleCancelDelete}
                        sx={{
                          ml: 1,
                          backgroundColor: "#ffcdd2",
                          borderRadius: "50%",
                          padding: "8px",
                          "&:hover": {
                            backgroundColor: "#ef9a9a"
                          }
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <IconButton
                        color="primary"
                        onClick={() => handleConfirmDelete(attch.id)}
                        sx={{
                          ml: 1,
                          backgroundColor: "#e0f7fa",
                          borderRadius: "50%",
                          padding: "8px",
                          "&:hover": {
                            backgroundColor: "#b2ebf2"
                          }
                        }}
                      >
                        <CheckIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <IconButton
                      color="error"
                      onClick={() => handleMarkForDelete(attch.id)}
                      sx={{ ml: 2 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
              ))
            ) : (
              ""
            )}
          </Box>
        </Grid>
      )}

      {/* Upload Box */}
      <Box
        sx={{
          mt: 1,
          p: 2,
          border: "1px dashed #ccc",
          borderRadius: "4px",
          backgroundColor: "#f9f9f9",
          textAlign: "center",
          cursor: "pointer"
        }}
      >
        <input
          type="file"
          multiple
          id="attachment-input"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
        <label
          htmlFor="attachment-input"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CloudUploadIcon sx={{ mr: 1 }} />
          <Typography variant="body2" color="text.secondary">
            Click or drag files to upload
          </Typography>
        </label>
      </Box>
    </div>
  );
};

export default AttachmentSection;
